import { ChevronRight } from "lucide-react"

type Props = {
  value: string
  isFullCellClickable?: boolean
  onClick: (id: string) => void
}

const ActionCell = ({ value, isFullCellClickable, onClick }: Props) => {
  const handleCellClick = () => {
    onClick(value)
  }

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick(value)
  }

  const cellClickHandler = isFullCellClickable ? handleCellClick : undefined
  const iconClickHandler = !isFullCellClickable ? handleIconClick : undefined

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-6 cursor-pointer"
      onClick={cellClickHandler}
    >
      <div className="flex items-center justify-end text-neutral-400">
        <ChevronRight onClick={iconClickHandler} />
      </div>
    </td>
  )
}

export default ActionCell
